let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = typeof handler === "function" ? handler : null;
}

export function notifyUnauthorized(detail) {
  if (!unauthorizedHandler) return;
  unauthorizedHandler(detail);
}
